import 'intersection-observer';
import scrollama from 'scrollama';
import ScrollerMap from './modules/scroller-map';
import debounce from 'lodash/debounce';

import img from '../assets/mobile-link-map.png';

function init() {
  const map = new ScrollerMap();
  const steps = document.querySelectorAll('.scroll-container .step');
  const scroller = scrollama();

  handleResize();

  let trigger = 0.5;
  if (window.innerWidth < 768) {
    trigger = 0.9;
  }

  scroller
    .setup({
      step: '.step',
      offset: trigger
    })
    .onStepEnter(r => {
      map.animateTo(r.element.id);
    });

  window.addEventListener('resize', debounce(handleResize, 150));

  function handleResize() {
    map.resize();
    steps.forEach(e => (e.style.height = window.innerHeight + 'px'));
    scroller.resize();
  }
}

// app fallback solution courtesy of Stackoverflow user @hexalys
if (navigator.platform.substr(0, 2) === 'iP') {
  let lte9 = /constructor/i.test(window.HTMLElement);
  let nav = window.navigator;
  let ua = nav.userAgent;
  let idb = !!window.indexedDB;

  if (
    ua.indexOf('Safari') !== -1 &&
    ua.indexOf('Version') !== -1 &&
    !nav.standalone
  ) {
    // iOS Safari.app
    init();    

  } else if ((!idb && lte9) || !window.statusbar.visible) {
    // UIWebView -- McClatchy iOS apps
    // If the apps switch to WKWebView this implementation won't work anymore

    let el = document.getElementById('gold-map');
    let sContainer = document.querySelector('.scroll-container');

    let esURL =
      'https://www.elnuevoherald.com/noticias/mundo/america-latina/venezuela-es/article232540632.html';
    let esText = 'Haga clic para ver el gráfico';

    if (el.dataset.es == 'false') {
      esURL =
        'https://www.miamiherald.com/news/nation-world/world/americas/venezuela/article230669164.html';
      esText = 'Click to view the graphic';
    }

    el.innerHTML = `<div class="app-fallback"><span><a href="${esURL}">${esText}</a></span><img src="${img}"/></div>`;
    sContainer.style.display = 'none';

  } else if ((window.webkit && window.webkit.messageHandlers) || !lte9 || idb) {
    // WKWebView -- Renders for browser views like the Facebook iOS app
    init();
  }
} else {
  // Do the thing everywhere else
  init();
}
